import React, {useEffect, useState} from "react";
import {Button, Card, Col, Divider, Form, Input, InputNumber, Row, Select, Space, Spin, Switch, Typography} from "antd";

import {SaveOutlined,} from "@ant-design/icons";

import {useApiLocationCountry} from "@/api/location";
import ProvinceCityCMP from "@/components/provinceCity";
import RenderIf from "@/components/render-if";
import IranMap from "@/components/map/Map";

const {Title, Text} = Typography;
const {TextArea} = Input;


export default function ClassroomForm({
                                          classroomData,
                                          onSubmit,
                                          loading
                                      }) {

    const [myCountry, setMyCountry] = useState('IR')
    const [multiClass, setMultiClass] = useState(false)
    const [countryList, setCountryList] = useState([])
    const [city, setCity] = useState()
    const [province, setProvince] = useState()
    const [location, setLocation] = useState({
        latitude: 0,
        longitude: 0
    })

    const [form] = Form.useForm();

    const {data: country} = useApiLocationCountry()

    useEffect(() => {
        if (classroomData?.country) {
            setMyCountry(classroomData?.country)
        }

        if (classroomData?.province) {
            setProvince(classroomData.province)
        }

        if (classroomData?.multiclass) {
            setMultiClass(true)
        }

        if (classroomData?.city) {
            setCity(classroomData.city)
        }

        if (classroomData?.latitude && classroomData?.longitude) {
            setLocation({
                latitude: classroomData?.latitude,
                longitude: classroomData?.longitude
            })
        }

    }, [classroomData?.city, classroomData?.province, classroomData?.longitude, classroomData?.latitude]);

    useEffect(() => {
        if (country?.data?.length > 0) {
            setCountryList(country?.data)
        }
    }, [country])


    useEffect(() => {
        if (classroomData) {
            form.setFieldsValue({
                ...classroomData,
                locationPoint: {
                    latitude: classroomData.latitude,
                    longitude: classroomData.longitude
                }
            });
        }
    }, [classroomData]);

    const handleFinish = (values) => {

        values.latitude = location.latitude;
        values.longitude = location?.longitude;
        values.multiclass = multiClass;
        if (city) {
            values.city = city
        }

        if (province) {
            values.province = province
        }

        delete values.locationPoint;


        onSubmit(values);
    };


    return (
        <Spin spinning={loading}>

            <Form
                form={form}
                layout="vertical"
                onFinish={handleFinish}
            >

                <Row gutter={[24, 24]}>

                    {/* اطلاعات اصلی */}

                    <Col xs={24}>
                        <Card bordered={false}>
                            <Title level={4}>
                                اطلاعات اصلی کلاس
                            </Title>

                            <Row gutter={16}>

                                <Col xs={24} md={12}>
                                    <Form.Item
                                        label="عنوان کلاس"
                                        name="title"
                                        rules={[
                                            {
                                                required: true,
                                                message: "عنوان الزامی است"
                                            }
                                        ]}
                                    >
                                        <Input size=""/>
                                    </Form.Item>
                                </Col>

                                <Col xs={24} md={6}>
                                    <Form.Item
                                        label="حداکثر ظرفیت"
                                        name="maxperson"
                                    >
                                        <InputNumber
                                            size=""
                                            min={1}
                                            style={{width: "100%"}}
                                        />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} md={6}>
                                    <Form.Item
                                        label="وضعیت"
                                        name="status"
                                    >
                                        <Select
                                            size=""
                                            options={[
                                                {
                                                    label: "فعال",
                                                    value: "enable"
                                                },
                                                {
                                                    label: "غیرفعال",
                                                    value: "disable"
                                                }
                                            ]}
                                        />
                                    </Form.Item>
                                </Col>

                                <Col span={24}>
                                    <Form.Item
                                        label="چندکلاسه"

                                        name="multiclass"
                                        valuePropName="checked"
                                    >
                                        <div className={'flex flex-col'}>

                                            <span className={'text-gray-400'}>با فعال بودن این گزینه امکان برگزاری چندین کلاس به صورت همزمان در این مکان وجود خواهد داشت. برای مواردی که محل برگزاری کلاس به صورت عمومی و بزرگ است این قسمت را فعال کنید</span>
                                            <div>
                                                <Switch
                                                    onChange={(e) => setMultiClass(e)}
                                                    checked={multiClass}/>
                                            </div>
                                        </div>


                                    </Form.Item>
                                </Col>

                                <Col span={24}>
                                    <Form.Item
                                        label="توضیحات"
                                        name="desc"
                                    >
                                        <Input.TextArea
                                            rows={5}
                                        />
                                    </Form.Item>
                                </Col>

                            </Row>
                        </Card>
                    </Col>

                    {/* آدرس */}

                    <Col xs={24}>
                        <Card bordered={false}>
                            <Title level={4}>
                                آدرس و موقعیت مکانی
                            </Title>

                            <Row gutter={16}>

                                <Col xs={24} md={8}>
                                    <Form.Item
                                        label="کشور"
                                        name="country"
                                    >
                                        <RenderIf condition={countryList?.length > 0}>
                                            <Select
                                                className={'block'}
                                                placeholder={'انتخاب کنید'}
                                                id={'nationality'}
                                                value={classroomData?.country}
                                                onChange={(e) => setMyCountry(e)}
                                                options={countryList.map((value, i) => {
                                                    return {value: value.key, label: value.fa_name}
                                                })}
                                            />
                                        </RenderIf>

                                        {myCountry === 'IR' && (<div>
                                            <ProvinceCityCMP setCity={setCity}
                                                             setProvince={setProvince}
                                                             currentCity={city}
                                                             currentProvince={province}/>
                                        </div>)}

                                    </Form.Item>


                                    <Form.Item
                                        label="منطقه"
                                        name="area"
                                    >
                                        <Input size=""/>
                                    </Form.Item>


                                    <Form.Item
                                        label="خیابان"
                                        name="street"
                                    >
                                        <Input size=""/>
                                    </Form.Item>
                                </Col>


                                <Col span={24}>
                                    <Form.Item
                                        label="آدرس کامل"
                                        name="address"
                                    >
                                        <Input.TextArea rows={3}/>
                                    </Form.Item>
                                </Col>

                            </Row>

                            <Divider/>

                            <div className="flex flex-wrap gap-2">
                                <div>
                                    <Title level={4}>
                                        مختصات جغرافیایی
                                    </Title>

                                </div>

                                <div className={'w-full'}>
                                    <Space
                                        direction="vertical"
                                        style={{width: "100%"}}
                                    >
                                        <Text>
                                            روی نقشه کلیک کنید تا موقعیت ثبت شود
                                        </Text>

                                        <Form.Item
                                            name="locationPoint"
                                        >
                                            <div className={'h-[600px]'}>
                                                <IranMap onChange={setLocation}
                                                         lockPoint={classroomData}/>
                                            </div>

                                        </Form.Item>
                                    </Space>

                                </div>
                                <div className="flex gap-2">

                                    <Form.Item
                                        label="عرض جغرافیایی"
                                        name="latitude"
                                    >
                                        <Input
                                            size=""
                                            value={location.latitude}
                                            readOnly
                                            disabled={true}
                                        />

                                    </Form.Item>
                                    <Form.Item
                                        label="طول جغرافیایی"
                                        name="longitude"
                                    >
                                        <Input
                                            size=""
                                            value={location.longitude}
                                            disabled={true}
                                            readOnly
                                        />

                                    </Form.Item>


                                </div>
                            </div>


                        </Card>
                    </Col>


                </Row>

                <Card
                    style={{
                        marginTop: 24
                    }}
                >

                    <div className={'flex justify-end'}>
                        <Button
                            type="primary"
                            htmlType="submit"
                            icon={<SaveOutlined/>}
                            size=""
                            loading={loading}
                        >
                            ذخیره تغییرات
                        </Button>
                    </div>

                </Card>

            </Form>

        </Spin>
    );
}